module.exports = __webpack_public_path__ + "img/unload-3-1.6975837e.png";